import axios from "axios";
import * as api from "./request";

export class InputModuleService {

    // Companies 
    public async fetchCompaniesDetails(data: any) {
        const url = `/api/v1/companies`
        return await api.get(url, data);
    }

    public async fetchAssociateCompaniesDetails(data: any) {
        const url = `/api/v1/companies`
        return await api.get(url, data);
    }

    public async getLocations(data: any) {
        const url = `/api/v1/company_location_mappings`
        return await api.get(url, data)
    }
    
    public async getStatesDetails(data: any) {
        const url = `/api/v1/states`
        return await api.get(url, data)
    }

    public async getActs(data: any) {
        const url = `/api/v1/acts`
        return await api.get(url, data)
    }

    public async getActivities(data: any) {
        const url = `/api/v1/activities`
        return await api.get(url, data)
    }

    public async getRules(data: any) {
        const url = `/api/v1/rules`
        return await api.get(url, data)
    }
    
    public async getForms(data: any) {
        const url = `/api/Mappings/GetActStateList`
        return await api.post(url, data)
    }

    public async getStateConfigurationDetails(fileUrl: any) {
        const url = `/api/StateRegisterConfiguration/GetStateConfigurationDetails?url=${fileUrl}`
        return await api.get(url)
    }

    public async getCompanyEmployerSubContractors(data: any) {
        const url = `/api/v1/company_employer_sub_contractors`
        return await api.get(url, data)
    }


    //Employee Master uploads
    public async configUpload(data: any) {
        // const url = `/api/Configuration/upload`
        const url = `/api/v1/configurations/bulk_upload`
        return await api.post(url, data, null, true, { responseType: 'blob' })
    }

    public async getColumns(type:string) {
        const url = `/api/v1/configurations/get_columns?configuration_type=${type}`
        return await api.get(url)
    }

    public async downloadFormat(type:string, associate_company_id: string, establishment_type?: string, location_id?: string, employer_id?: string) {
        let url = `/api/v1/configurations/download_format?`+
                    `configuration_type=${type}&`+
                    `associate_company_id=${associate_company_id}` +
                    `&establishment_type=${establishment_type}` +
                    `&is_assoc_cmp_config=${!employer_id ? true : false}`;
        if (establishment_type == 'CLRA' && location_id) {
            url += `&location_id=${location_id}`;
        }
        if (establishment_type == 'CLRA' && employer_id) {
            url += `&employer_id=${employer_id}`;
        }
        return await api.get(url,null, true, { responseType: 'blob' })
    }

    public async callExcelHeaderToDbColumns(data: any) {
        // const url = `/api/Configuration/ExcelHeaderToDBColumns`
         const url = `/api/v1/configurations/bulk_excel_header_to_db_columns`
        return await api.post(url, data)
    }
    
    public async employeeUpload(data: any) {
        //const url = `/api/Configuration/UploadEmployeeMaster`
            const url = `/api/v1/employees/import`
        return await api.post(url, data, null, true, { responseType: 'blob' })
    }
    
    public async employeeAttendanceUpload(data: any) {
            const url = `/api/v1/employee_attendances/import`
        //const url = `/api/Configuration/UploadEmployeeAttendance`
        return await api.post(url, data, null, true, { responseType: 'blob' })
    }

    public async employeeLeaveBalanceUpload(data: any) {
        //const url = `/api/Configuration/UploadEmployeeLeaveBalance`
         const url = `/api/v1/employee_leave_credits/import`
        return await api.post(url, data, null, true, { responseType: 'blob' })
    }
    
    public async employeeLeaveAvailedUpload(data: any) {
         const url = `/api/v1/employee_leave_availeds/import`
        //const url = `/api/Configuration/UploadEmployeeLeaveAvailed`
        return await api.post(url, data, null, true, { responseType: 'blob' })
    }

    public async employeeWageUpload(data: any) {
        
        const url = `/api/v1/employee_wages/import`
        //const url = `/api/Configuration/UploadEmployeeWage`
        return await api.post(url, data, null, true, { responseType: 'blob' })
    }

    public async getInputModuleMappingDetails(data: any) {
        const url = `/api/v1/employee_upload_configurations`
        return await api.get(url, data)
    }

    // Dashboard
    public async getEmployeeDashboardCounts(data: any) {
        const url = `/api/v1/employee_dashboards`
        return await api.get(url, data)
    }

    public async getEmployeeInputDashboard(data: any) {
        const url = `/api/v1/employee_input_dashboards`
        const response:any = await api.get(url, data);
        return response;
    }

    public async getEmployeeBackendCount(data: any) {
        const url = `/api/Dashboard/EmployeeBackendCount`
        return await api.get(url, data)
    }

    public async getErrorLogs(data: any) {
        const url = `/api/Configuration/GetInputErrorFileTransactions`
        return await api.get(url, data)
    }


    // Holidays list
    public async fetchHolidaysList(data: any) {
        const url = `/api/v1/holidays`
        return await api.get(url, data)
    }

    public async deleteHoliday(id:any) {
        const url =  `/api/v1/holidays/${id}`
        return await api.del(url)
    }

    public async addHoliday(data: any) {
        const url = `/api/v1/holidays`
        return await api.post(url, data)
    }

    public async uploadHoliday(data: any) {
        const url = `/api/v1/holidays/import`
        return await api.post(url, data, null, true, { responseType: 'blob' })
    }

    public async editHoliday(data: any) {
        const url = `/api/v1/holidays/${data.id}`
        return await api.put(url, data)
    }

    public async bulkDeleteHolidays(data: any) {
        const url = `/api/v1/holidays/delete_all`
        return await api.del(url, data)
    } 

    // Leave Configuration
    public async fetchLeaveConfiguration(data: any) {
        const url = `/api/v1/leaves`
        return await api.get(url, {...data, include: { company: { only: ['id','name'] }, associate_company: {only: ['id', 'name']}, location: {only: ['id', 'name']} }, includes: ['company', 'associate_company', 'location']})
    }

    public async deleteLeaveConfiguration(id:any) {
        const url =  `/api/v1/leaves/${id}`
        return await api.del(url)
    }

    public async addLeaveConfiguration(data: any) {
        const url = `/api/v1/leaves`
        return await api.post(url, data)
    }

    public async uploadLeaveConfiguration(data: any) {
        const url = `/api/v1/leaves/import`
        return await api.post(url, data, null, true, { responseType: 'blob' })
    }

    public async editLeaveConfiguration(data: any) {
        const url = `/api/v1/leaves/${data.id}`
        return await api.put(url, data)
    }

    public async bulkDeleteLeaves(data: any) {
        const url = `/api/v1/leaves/delete_all`
        return await api.post(url, data)
    } 

    // Attendance Configuration
    public async fetchAttendanceConfiguration(data: any) {
        const url = `/api/v1/attendances`
        return await api.get(url, {...data, include: { company: { only: ['id','name'] }, associate_company: {only: ['id', 'name']}, location: {only: ['id', 'name']} }, includes: ['company', 'associate_company', 'location']})
    }

    public async deleteAttendanceConfiguration(id:any) {
        const url =  `/api/v1/attendances/${id}`
        return await api.del(url)
    }

    public async addAttendanceConfiguration(data: any) {
        const url = `/api/v1/attendances`
        return await api.post(url, data)
    }

    public async uploadAttendanceConfiguration(data: any) {
        const url = `/api/v1/attendances/import`
        return await api.post(url, data, null, true, { responseType: 'blob' })
    }

    public async editAttendanceConfiguration(data: any) {
        const url = `/api/v1/attendances/${data.id}`
        return await api.put(url, data)
    }

    public async bulkDeleteAttendance(data: any) {
        const url = `/api/v1/attendances/delete_all`
        return await api.del(url, data)
    } 

    // State Register
    public async fetchStateRegister(data: any) {
        const url = `/api/v1/state_register_configurations`
        return await api.get(url, data)
    }
    public async fetchStateRegisterDownload(data: any) {
        const url = `/api/v1/state_registers`
        return await api.get(url, data)
    }
    public async fetchStateRegisterZipFileDownload(data: any) {
        const url = `/api/v1/state_registers/get_zip_file_download`
        return await api.post(url, data)
    }

    public async addStateRegister(data: any) {
        const url = `/api/v1/state_register_configurations`
        return await api.post(url, data)
    }

    public async updateStateRegister(data: any) {
        const url = `/api/v1/state_register_configurations/${data.id}`
        return await api.post(url, data)
    }

   // State RegisterQue
    public async fetchStateRegisterQue(data: any) {
        const url = `/api/v1/state_register_ques`
        return await api.get(url, data)
    }
    
    public async fetchStateRegisterQueDownload(data: any) {
        const url = `/api/v1/state_register_ques`
        return await api.get(url, data)
    }

    public async fetchStateRegisterQueExcelandPdfDownload(data: any) {
        const url = `/api/v1/state_registers/get_excel_and_pdf_zip_file_download`
        return await api.post(url, data)
    }

    public async addStateRegisterQue(data: any, establishmentType: string) {
        let url = `/api/v1/state_register_ques`
        switch (establishmentType) {
            case 'CLRA':
                url = `/api/v1/state_register_ques/create_clra_que`
                break;
            case 'Shops':
                url = `/api/v1/state_register_ques`
                break;
            default:
                url = `/api/v1/state_register_ques`
                break;
        }
        return await api.post(url, data)
    }

    public async updateStateRegisterQue(data: any) {
        const url = `/api/v1/state_register_ques/${data.id}`
        return await api.post(url, data)
    }
    
    //Employee Master
    public async getEmployees(data: any) {
        const url = `/api/v1/employees`
        return await api.get(url, data)
    }
    
    public async getEmployeesAttendance(data: any) {
        const url = `/api/v1/employee_attendances`
        return await api.get(url, data)
    }
    
    public async getEmployeesLeaveBalance(data: any) {
        const url = `/api/v1/employee_leave_credits`
        return await api.get(url, data)
    }
    
    public async getEmployeesLeaveAvailed(data: any) {
        const url = `/api/v1/employee_leave_availeds`
        return await api.get(url, data)
    }
    
    public async getEmployeesWage(data: any) {
        const url = `/api/v1/employee_wages`
        return await api.get(url, data)
    }
    public async bulkDeleteEmployees(data: any) {
        const url = `/api/v1/employees/delete_many`
        return await api.del(url, data)
    }

    //Salary Components
    public async salaryComponentUpload(data: any) {
        const url = `/api/Configuration/UploadSalaryComponent`
        return await api.post(url, data, null, true)
    }

    public async salaryComponentConfigUpload(data: any) {
        const url = `/api/Configuration/SalaryComponentConfigurationUpload`
        return await api.post(url, data, null, true)
    }

    public async callSalaryComponentsExcelHeaderToDbColumns(data: any) {
        const url = `/api/Configuration/UpdateSalaryExcelHeadertoDBColumnsMap`
        return await api.post(url, data)
    }

    public async getSalaryComponentsDetails(data: any) {
        const url = `/api/Employee/GetAllSalaryComponent`
        return await api.post(url, data)
    }

    public async getSalaryComponentsMappingDetails(data: any) {
        const url = `/api/Configuration/GetSalaryConfigAll`
        return await api.post(url, data)
    }

    //leave credit 
    public async bulkDeleteLeaveBalance(data: any) {
        const url = `/api/Leave/EmployeeLeaveBalBulkDelete`
        return await api.post(url, data)
    }

    //leave availed

    public async bulkDeleteLeaveAvailed(data: any) {
        const url = `/api/Leave/EmployeeAvailedBulkDelete`
        return await api.post(url, data)
    }

    //Employee Attendance
    
    public async bulkDeleteEmployeeAttendance(data: any) {
        const url = `/api/Employee/EmployeeAttendanceBulkDelete`
        return await api.post(url, data)
    }

    // Employee Wage 
    public async bulkDeleteEmployeeWage(data: any) {
        const url = `/api/Employee/EmployeeWageBulkDelete`
        return await api.post(url, data)
    }


    
   //  state act rule activity mapping 
   public async deleteActStateMappingForm(id: any) {
    const url = `/api/ActStateMapping/DeleteForm?id=${id}`
    return await api.del(url) 
   }

   //delete state register comnfiguration mapping 
   public async deleteStateRegisterMapping(id:any) {

    const url =  `/api/StateRegisterConfiguration/Delete?Id=${id}`
    return await api.del(url)
}


   // Export State Register Mapping
   public async exportStateRegisterMapping(url: string) {
          const exportUrl = `/api/StateRegisterConfiguration/ExportStateRegisterMapping?url=${url}`
    //const exportUrl = `/api/StateRegisterConfiguration/ExportStateRegisterMapping?url=${encodeURIComponent(url)}`;
       //return await api.post(exporturl, null, null, true, { responseType: 'blob' })
  //  const response = await  api.post(exporturl, {}, { responseType: 'blob' });
    //return response.data; // This will be the blob
    //const response = await api.post(exportUrl, {}, { responseType: 'blob' });
    const response = await api.post(exportUrl, {}, null, true, { responseType: 'blob' })
    return response.data; // This will be the blob
}

  // import State Register Mapping
  public async importStateRegisterMapping(data: any) {
    const url = `/api/StateRegisterConfiguration/ImportStateRegisterConfigurationRequest`
    return await api.post(url, data, null, true,{ responseType: 'blob' })
}

  


}